import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';
import { useFormContext } from 'react-hook-form';

type OrderBlocksFieldsProps = {
  path: IndicatorIndexedPath;
};

export const OrderBlocksFields: FC<OrderBlocksFieldsProps> = ({ path }) => {
  const { watch } = useFormContext();

  const mitigated = watch(`${path}.cancelOnMitigation`);

  return (
    <>
      <TradingFormField
        type="numeric"
        name={`${path}.gapCandleSizeRatio`}
        label="Gap candle size ratio"
      />
      <TradingFormField
        type="checkbox"
        name={`${path}.cancelOnMitigation`}
        label="Cancel on mitigation"
        checked={mitigated}
      />
    </>
  );
};
